import { Button } from "@material-ui/core";
import React from "react";

export const Interact = ({ onFinish, userMediaReady }) => {
  const searchParams = new URLSearchParams(window.location.search);
  const isUserInactive = searchParams.get("user_inactive") === "true";
  const isSessionEnded = searchParams.get("session_ended") === "true";

  return (
    <center>
      <div className="containerBig">
        <div className="vertical-center">
          {isSessionEnded ? (
            <div style={{ color: "white", padding: "20px" }}>
              <p style={{ fontSize: "1.2rem", marginBottom: "10px" }}>The session is over.</p>
              <p>You may close this window. Thanks for using JamKazam!</p>
            </div>
          ) : userMediaReady ? (
            <>
              <Button
                color="primary"
                variant="contained"
                size="large"
                onClick={onFinish}
                style={{ marginBottom: isUserInactive ? "16px" : "0" }}
              >
                {isUserInactive ? "Re-join" : "Join room"}
              </Button>
              {isUserInactive && (
                <p style={{ color: "white", fontSize: "0.9rem", opacity: 0.8 }}>
                  You were logged out of your video session after a long period of usage; you can re-join the room
                </p>
              )}
            </>
          ) : (
            <p style={{ color: "white" }}>Waiting for camera permissions...</p>
          )}
        </div>
      </div>
    </center>
  );
};
